<!-- Modal Header -->
<div class="modal-header border-0 pb-2">
  <div class="d-flex align-items-center flex-grow-1">
    <div class="registration-icon me-3">
      <i class="bi bi-person-plus-fill"></i>
    </div>
    <div>
      <h4 class="modal-title mb-1">ใบคำขอขึ้นชั้นทะเบียนผู้ประเมินหลัก</h4>
      <p class="text-muted mb-0 small">ระบบการจัดเก็บและจัดการ CPD Hours • สำหรับสมาชิกสมาคมผู้ประเมินค่าทรัพย์สินไทย
      </p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<!-- Progress Bar -->
<div class="modal-progress">
  <div class="progress">
    <div class="progress-bar bg-success" role="progressbar" [style.width.%]="getProgressPercentage()"
      [attr.aria-valuenow]="getProgressPercentage()" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
  <div class="progress-steps">
    <div class="step-container">
      <div *ngFor="let step of [1, 2]" class="step-item">
        <div class="step-circle" [class.completed]="isStepCompleted(step)" [class.current]="isStepCurrent(step)"
          [class.clickable]="step <= currentStep" (click)="goToStep(step)">
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
          <i *ngIf="isStepCurrent(step)" class="{{ getStepIcon(step) }}"></i>
          <span *ngIf="!isStepCompleted(step) && !isStepCurrent(step)">{{ step }}</span>
        </div>
        <div class="step-label">{{ getStepTitle(step) }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">

    <!-- Step 1: Appraiser Registration Information -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-file-earmark-text me-2"></i>ขั้นตอนที่ 1. ข้อมูลการสมัคร
        </h5>
        <p class="step-description">กรอกข้อมูลการสมัครขึ้นทะเบียนผู้ประเมิน</p>
      </div>

      <div class="row">
        <!-- Appraiser Level Dropdown -->
        <div class="col-md-12 mb-4">
          <label class="form-label required">ชั้นผู้ประเมินที่ต้องการขึ้นทะเบียน</label>
          <div class="appraiser-level-options">
            <div *ngFor="let level of appraiserLevels" class="form-check mb-2">
              <input class="form-check-input" type="radio" [value]="level.value" formControlName="appraiserLevel"
                [id]="'appraiser-' + level.value">
              <label class="form-check-label" [for]="'appraiser-' + level.value">
                {{ level.label }}
              </label>
            </div>
          </div>
          <div class="invalid-feedback d-block" *ngIf="hasError('appraiserLevel')">
            {{ getErrorMessage('appraiserLevel') }}
          </div>
        </div>

        <!-- Fee Display -->
        <div class="col-md-12 mb-4">
          <div class="alert alert-info d-flex align-items-center">
            <i class="bi bi-info-circle me-2"></i>
            <span *ngIf="isLoadingPrice" class="d-flex align-items-center gap-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              กำลังโหลดค่าธรรมเนียม...
            </span>
            <strong *ngIf="!isLoadingPrice && priceSetup">
              ค่าธรรมเนียมที่ต้องชำระ: {{ priceSetup.price | number:'1.2-2' }} บาท (รวม vat)
            </strong>
            <span *ngIf="!isLoadingPrice && !priceSetup" class="text-danger">
              ไม่สามารถโหลดข้อมูลค่าธรรมเนียมได้
            </span>
          </div>
        </div>

        <!-- Document Upload Section -->
        <div class="col-12 mb-3">
          <label class="form-label">เอกสารประกอบการพิจารณา <span class="text-danger">*</span></label>

          <!-- Required docs panel -->
          <div class="required-docs-panel mb-3">
            <div class="required-docs-panel-header">
              <i class="bi bi-list-check me-2"></i>
              เอกสารที่ต้องเตรียม <span class="badge-count">{{ requiredDocLabels.length }} รายการ</span>
              <span class="format-hint">PDF, JPG, JPEG, PNG • ไม่เกิน 5MB</span>
            </div>
            <div class="required-docs-grid">
              <div class="required-doc-chip" *ngFor="let doc of requiredDocLabels; let i = index">
                <span class="chip-num">{{ i + 1 }}</span>
                <span class="chip-text">{{ doc }}</span>
              </div>
            </div>
          </div>

          <!-- Hidden file input -->
          <input type="file" #fileInput id="file-upload" accept=".pdf,.jpg,.jpeg,.png"
            (change)="onFilesSelected($event)" hidden>

          <!-- Drag & drop upload zone -->
          <div class="upload-zone"
            [class.drag-over]="isDragOver"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInput.click()">
            <div class="upload-zone-icon">
              <i class="bi bi-cloud-arrow-up-fill"></i>
            </div>
            <p class="upload-zone-title">
              ลากไฟล์มาวางที่นี่ หรือ <span class="upload-zone-cta">คลิกเพื่อเลือกไฟล์</span>
            </p>
            <p class="upload-zone-hint">รองรับ PDF, JPG, JPEG, PNG • ขนาดไม่เกิน 5MB</p>
          </div>

          <!-- Uploading indicator -->
          <div class="d-flex align-items-center gap-2 text-primary mt-3" *ngIf="isUploadingFile">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="small fw-semibold">กำลังอัพโหลด...</span>
          </div>

          <!-- Selected file display -->
          <div class="files-container" *ngIf="uploadedFile && !isUploadingFile">
            <div class="file-row">
              <div class="file-row-icon" [ngClass]="getFileIconClass(uploadedFile.name)">
                <i class="bi" [ngClass]="getFileIcon(uploadedFile.name)"></i>
              </div>
              <div class="file-row-info">
                <p class="file-row-name">{{ uploadedFile.name }}</p>
                <p class="file-row-size">{{ formatFileSize(uploadedFile.size) }}</p>
              </div>
              <button type="button" class="btn-change-file" (click)="fileInput.click(); $event.stopPropagation()">
                <i class="bi bi-arrow-repeat me-1"></i>เปลี่ยนไฟล์
              </button>
              <button type="button" class="btn-remove-file" (click)="removeFile(); $event.stopPropagation()" title="ลบไฟล์">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: General Information and Review -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-person-check me-2"></i>ขั้นตอนที่ 2. ตรวจสอบข้อมูลและยืนยัน
        </h5>
        <p class="step-description">ตรวจสอบข้อมูลส่วนตัวและข้อมูลการสมัครให้ถูกต้อง</p>
      </div>

      <!-- Review Section (Part of Step 2) -->
      <div class="review-container mt-4">
        <!-- Application Information Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-file-earmark-text me-2"></i>ข้อมูลการสมัคร
          </h6>
          <div class="review-grid">
            <div class="review-item">
              <span class="review-label">ชั้นผู้ประเมินที่ต้องการขึ้นทะเบียน:</span>
              <span class="review-value">
                <span class="badge bg-primary">
                  {{ getAppraiserLevelLabel() }}
                </span>
              </span>
            </div>
            <div class="review-item" *ngIf="priceSetup">
              <span class="review-label">ค่าธรรมเนียมที่ต้องชำระ:</span>
              <span class="review-value">
                <strong>{{ priceSetup.price | number:'1.2-2' }} บาท (รวม vat)</strong>
              </span>
            </div>
          </div>
        </div>

        <!-- Uploaded Documents Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-paperclip me-2"></i>เอกสารประกอบการพิจารณา
          </h6>
          <div class="review-files-list" *ngIf="uploadedFile && !isUploadingFile">
            <div class="review-file-item">
              <div class="review-file-icon" [ngClass]="getFileIconClass(uploadedFile.name)">
                <i class="bi" [ngClass]="getFileIcon(uploadedFile.name)"></i>
              </div>
              <div class="review-file-info">
                <span class="review-file-name">{{ uploadedFile.name }}</span>
                <span class="review-file-size">{{ formatFileSize(uploadedFile.size) }}</span>
              </div>
              <span class="review-file-badge">
                <i class="bi bi-check-circle-fill me-1"></i>พร้อมอัพโหลด
              </span>
            </div>
          </div>
          <div *ngIf="isUploadingFile" class="text-primary small p-3">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            กำลังอัพโหลดเอกสาร...
          </div>
          <div *ngIf="!uploadedFile && !isUploadingFile" class="review-no-files">
            <i class="bi bi-exclamation-circle me-2"></i>ยังไม่ได้เลือกเอกสาร
          </div>
        </div>

        <!-- Confirmation Message -->
        <div class="alert alert-info mt-4">
          <i class="bi bi-info-circle me-2"></i>
          <strong>หมายเหตุ:</strong> กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่ม "ส่งคำขอสมัคร" หากต้องการแก้ไขข้อมูล
          สามารถกดปุ่ม "ย้อนกลับ" เพื่อแก้ไขได้
        </div>
      </div>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="prevStep()" *ngIf="currentStep > 1"
    [disabled]="isSubmitting">
    <i class="bi bi-arrow-left me-1"></i>ย้อนกลับ
  </button>
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isSubmitting">
    ยกเลิก
  </button>
  <button type="button" class="btn btn-success" (click)="nextStep()" *ngIf="currentStep < totalSteps"
    [disabled]="isSubmitting">
    ถัดไป<i class="bi bi-arrow-right ms-1"></i>
  </button>
  <button type="button" class="btn btn-success" (click)="onSubmit()" *ngIf="currentStep === totalSteps"
    [disabled]="isSubmitting || registrationForm.invalid">
    <span *ngIf="!isSubmitting">
      <i class="bi bi-check-circle me-1"></i>ยืนยันและส่งข้อมูล
    </span>
    <span *ngIf="isSubmitting">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      กำลังส่งข้อมูล...
    </span>
  </button>
</div>